"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var SchemaType;
(function (SchemaType) {
    SchemaType[SchemaType["Default"] = 0] = "Default";
    SchemaType[SchemaType["Car"] = 1] = "Car";
    SchemaType[SchemaType["Motorbike"] = 2] = "Motorbike";
    SchemaType[SchemaType["Trailer"] = 4] = "Trailer";
    SchemaType[SchemaType["Camper"] = 8] = "Camper";
    SchemaType[SchemaType["CampingTrailer"] = 16] = "CampingTrailer";
})(SchemaType = exports.SchemaType || (exports.SchemaType = {}));
var SchemaTypeName;
(function (SchemaTypeName) {
    SchemaTypeName["Default"] = "Default";
    SchemaTypeName["Car"] = "Car";
    SchemaTypeName["Motorbike"] = "Motorbike";
    SchemaTypeName["Trailer"] = "Trailer";
    SchemaTypeName["Camper"] = "Camper";
    SchemaTypeName["CampingTrailer"] = "CampingTrailer";
})(SchemaTypeName = exports.SchemaTypeName || (exports.SchemaTypeName = {}));
exports.SCHEMA_TYPES = (_a = {},
    _a[SchemaTypeName.Default] = SchemaType.Default,
    _a[SchemaTypeName.Car] = SchemaType.Car,
    _a[SchemaTypeName.Motorbike] = SchemaType.Motorbike,
    _a[SchemaTypeName.Trailer] = SchemaType.Trailer,
    _a[SchemaTypeName.Camper] = SchemaType.Camper,
    _a[SchemaTypeName.CampingTrailer] = SchemaType.CampingTrailer,
    _a);
exports.SCHEMA_TYPE_NAMES = Object.keys(exports.SCHEMA_TYPES).reduce(function (acc, e) {
    acc[SchemaType[e]] = e;
    return acc;
}, {});
//# sourceMappingURL=SchemaType.js.map